import { Footer } from "../MainPage/Footer/Footer";
import NavigationBar from "../NavigationBar/NavigationBar";
import About from "./About/About";
import { AiStartupHeading } from "./AiStartup/AiStartupHeading";
import ContactSection from "./Contact/ContactSection";
import MissionSection from "./Mission/MissionSection";
import { StorySection } from "./Story/StorySection";

function MainAboutUs() {
  return (
    <div className="App">
      <NavigationBar />
      <About />
      <AiStartupHeading />
      <MissionSection />
      <StorySection />
      <ContactSection />
      <Footer />
    </div>
  );
}

export default MainAboutUs;
